import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MuiLinearProgress from '@mui/material/LinearProgress';
import * as React from 'react';
import { FlexBox } from '../box';
import { styled } from '../styled';
import { Typography } from '../typography';
import { makeEnum } from '../utils';
export const LinearProgressSize = makeEnum('small', 'large');
const LINEAR_PROGRESS_HEIGHT = {
    small: 0.5,
    large: 1
};
const StyledLinearProgress = styled(MuiLinearProgress)(({ theme, $size }) => ({
    ...($size !== undefined && {
        height: theme.spacing(LINEAR_PROGRESS_HEIGHT[$size])
    })
}));
export const LinearProgress = React.forwardRef((props, ref) => {
    const { size = LinearProgressSize.small, ...muiProps } = props;
    return _jsx(StyledLinearProgress, { ref: ref, "$size": size, ...muiProps });
});
export const LinearProgressWithLabel = (props) => {
    const { label, sx, size = LinearProgressSize.small, ...muiProps } = props;
    return (_jsxs(FlexBox, { vAlign: "center", gap: 2, children: [_jsx(LinearProgress, { ...muiProps, size: size, sx: { width: '100%', ...sx } }), _jsx(Typography, { variant: "body2", children: label })] }));
};
